import { tabbable } from "tabbable";
import { getRootNode } from "./get-root-node.es.js";
function tabbableNext(node) {
  if (!node) {
    return void 0;
  }
  const tabbableNodes = tabbable(getRootNode(node));
  const index = tabbableNodes.indexOf(node);
  return index >= 0 && index < tabbableNodes.length - 1 ? tabbableNodes[index + 1] : void 0;
}
export {
  tabbableNext
};
